/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

import useTranslate from 'hooks/useTranslate';
import { useMarkdownTranslate } from 'hooks/useTranslate/useTranslate';
import PageContainer from 'components/PageContainer';
import CancelButton from 'features/CancelButton';
import ActionButtonContainer from 'components/ActionButtonsContainer';
import Button from 'components/Button';
import SimpleMessagePage from 'components/SimpleMessagePage';

interface PropTypes {
  restartPath: string;
}

const ExpiredView: React.FC<PropTypes> = ({ restartPath }) => {
  const t = useTranslate();
  const tMd = useMarkdownTranslate();
  return (
    <PageContainer>
      <SimpleMessagePage
        headerTitle={'prequal.expired.title'}
        message={tMd('prequal.expired.message')}
      >
        <ActionButtonContainer>
          <Button
            id="continueToApplication"
            variant="contained"
            href={restartPath}
          >
            {t('prequal.expired.continueButton')}
          </Button>

          <CancelButton />
        </ActionButtonContainer>
      </SimpleMessagePage>
    </PageContainer>
  );
};

export default ExpiredView;
